import axios from 'axios';
import _ from 'lodash';
const qs = require('qs');

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleGetVotesRequest = async (capsuleIds) => {

  try {
    const response = await instance.get(`/votes/?capsule_ids=${capsuleIds}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleCreateVoteRequest = async (capsuleId) => {
  let payload = { capsule_id: capsuleId }

  try {
    const response = await instance.post(`/votes/`, payload);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleDestroyVoteRequest = async (capsuleId) => {
  let payload = { capsule_id: capsuleId }

  try {
    const response = await instance.delete(`/votes`, { data: payload });

    return response;
  } catch (error) {
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/api/vote/index.js